import type { RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'

/**
 * The hr module's routes (WP-15, wp/hr §3): the employer's Time off and Timesheets (`hr` software, Time off / Timesheets
 * read — legacy `meta.roles` + `meta.module`; a Freelancer is refused by the software guard) and the employee's own
 * (`em` software, no ACL module, as legacy; OPEN-15 (a): the shell's software guard keeps Client and Staff out). Paths
 * and names from the route manifest (D-15); `/hr/leave_absence` and `/em/leave_absence` redirect here through the
 * generated `legacy-redirects.ts`, query kept (`?leaveId=`, `?timesheetId=`, `?start_date`, `?end_date`, `?status`).
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/hr/leave-absence',
    name: 'hr-leave-absence',
    component: () => import('./views/LeaveListView.vue'),
    meta: {
      software: 'hr',
      resource: 'leave_absence',
      pageTitle: keys.t('common.nav.timeOff'),
      breadcrumb: [{ text: keys.t('common.nav.timeOff'), active: true }],
    },
  },
  {
    path: '/hr/timesheets',
    name: 'hr-timesheets',
    component: () => import('./views/TimesheetListView.vue'),
    meta: {
      software: 'hr',
      resource: 'timesheets',
      pageTitle: keys.t('common.nav.timesheets'),
      breadcrumb: [{ text: keys.t('common.nav.timesheets'), active: true }],
    },
  },
  {
    path: '/em/leave-absence',
    name: 'em-leave-absence',
    component: () => import('./views/MyLeavesView.vue'),
    meta: {
      software: 'em',
      pageTitle: keys.t('common.nav.timeOff'),
      breadcrumb: [{ text: keys.t('common.nav.timeOff'), active: true }],
    },
  },
  {
    path: '/em/timesheets',
    name: 'em-timesheets',
    component: () => import('./views/MyTimesheetsView.vue'),
    meta: {
      software: 'em',
      pageTitle: keys.t('common.nav.timesheets'),
      breadcrumb: [{ text: keys.t('common.nav.timesheets'), active: true }],
    },
  },
]

export default routes
